// extracted by mini-css-extract-plugin
module.exports = {"title":"Dashboard_title__3_RaF","subTitle":"Dashboard_subTitle__14Di7"};